'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Icon = function Icon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      props = (0, _objectWithoutProperties3.default)(_ref, ['name', 'className']);

  return _react2.default.createElement('span', (0, _extends3.default)({
    className: (0, _classnames2.default)(className, (0, _defineProperty3.default)({}, 'am-icon-' + name, name))
  }, props));
};

Icon.defaultProps = {
  className: undefined
};

Icon.propTypes = {
  name: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string
};

exports.Icon = Icon;